/*
 * ******************************************************
 * Copyright (c) 2022 Jenke & Rauschert GbR <info@aiandor.de> - All Rights Reserved
 *
 * This file is part of a software product owned by the Jenke & Rauschert GbR.
 * Unauthorized distribution of this file is strictly prohibited.
 * ******************************************************
 */

import React from 'react';
import {ConfigProvider} from "antd";
import deDE from 'antd/lib/locale/de_DE';
import {HashRouter} from "react-router-dom";

import AppStore from "./store";
import AppAuthentication from "./authentication";
import AppLayout from "./layout";
import AppRoutes from "./routes";

import './style/app.css'

export default function App(props: any) {
    window.addEventListener('click', (e) => {
        //TODO: track activity
        console.debug("click");
        e.stopImmediatePropagation();
    })

    return (
        <React.StrictMode>
            <ConfigProvider
                locale={deDE}
            >
                <HashRouter hashType='slash'>
                    <AppStore>
                        <AppAuthentication>
                            <AppLayout>
                                <AppRoutes/>
                            </AppLayout>
                        </AppAuthentication>
                    </AppStore>
                </HashRouter>
            </ConfigProvider>
        </React.StrictMode>
    )
}



